<template>
  <div class="">
    <!-- Button trigger modal -->
    <button type="button" class="btn btn-primary btn-sm rounded-pill" data-toggle="modal"
            data-target="#setup-router-link">
      setup router link
    </button>

    <!-- Modal -->
    <div class="modal fade" id="setup-router-link" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <form @submit.prevent="submit">
            <div class="modal-body">

              <select class="custom-select" @change="setSelectedRouteParams" v-model="selectedRoute">
                <option value="">choose route</option>
                <option v-for="item in flatRoutes" :value="item">{{ item.name }}</option>
              </select>


              <div class="form-group" v-for="(item,index) in selectedRouteParams" :key="index">
                <label :for="`item-${index}`">{{ index }}</label>
                <input type="text" class="form-control" :id="`item-${index}`" v-model="selectedRouteParams[index]">
              </div>


            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
              <button type="submit" class="btn btn-primary">Save changes</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import {defineComponent} from 'vue'
import {siteRoutes} from "@moeinmdn/miw-router/src/package/routes/SiteRoutes";
import {findCustomRoutes, flatRouter} from "@/store/Modules/Site";

export default defineComponent({
  name: "SetupRouterLink",
  props: {
    component: {}
  },
  data() {
    return {
      siteRoutes,
      selectedRoute: '',
      selectedRouteParams: {}
    }
  },
  computed: {
    flatRoutes() {
      let mainRoutes = flatRouter(this.siteRoutes)
      let customRoutes = findCustomRoutes();
      return [...mainRoutes, ...customRoutes]
    }
  },
  methods: {
    flatRouter,
    submit() {
      let result = {
        name: this.selectedRoute.name,
        params: this.selectedRouteParams
      }
      let resultToString = JSON.stringify(result)
      this.component.props.href = resultToString
    },
    setSelectedRouteParams() {

      const paramRegex = /:([^/]+)/g;
      let match;

      let path = this.selectedRoute.path

      while ((match = paramRegex.exec(path))) {
        this.selectedRouteParams[match[1]] = ''
      }
    }
  },

})
</script>

<style scoped>

</style>